module.exports = __webpack_public_path__ + "assets/imgs/achs/gAnalytics.8436f0b54cacee935b8a6dfa877482af.png";